import React from "react";

import emptyDocs from "assets/images/Logo.svg";

import styles from "./ComingSoon.module.css";

export const ComingSoon = () => {
  return (
    <div className={styles.emptyState}>
      <img className={styles.element} alt="Element" src={emptyDocs} />
      <div className={styles.text}>
        <div className={styles.div}>
          <div className={styles.textWrapper}>Coming soon</div>
          <p className={styles.onceThePatient}>
            This feature is in development and will be with you shortly
          </p>
        </div>
      </div>
    </div>
  );
};
